import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { MenuItem } from 'primeng/api';
import { RouterLink } from '@angular/router';
import { TranslucentCardComponent } from '../card/translucent-card/translucent-card.component';

@Component({
  selector: 'ip-shared-time-line',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule, RouterLink, TranslucentCardComponent],
  templateUrl: 'time-line.component.html',
  styleUrls: ['time-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeLineComponent implements AfterViewInit, OnChanges {
  @Input() steps: Array<MenuItem> = [];
  @Input() stepId = '';
  @ViewChild('bar') circularBar: ElementRef | undefined;
  readonly radius = 35;
  stepNo = 0;
  totalSteps = 0;
  progressValue = 0;
  strokeDashOffset: number;

  constructor(private rd: Renderer2) {
    this.strokeDashOffset = Math.PI * 2 * this.radius;
  }

  _stepRapport = 0;

  get stepRapport() {
    return this._stepRapport ?? 0;
  }

  set stepRapport(_stepRapport) {
    this._stepRapport = _stepRapport;
  }

  ngOnChanges(): void {
    this.setCurrentStepAndStepRapport();
  }

  ngAfterViewInit(): void {
    this.setCurrentStepAndStepRapport();
  }

  getRouterLink(step: MenuItem): string {
    return Number(step.tabindex) <= this.stepNo ? step.routerLink : null;
  }

  getItemTabIndex(step: MenuItem): string {
    return step.tabindex ?? '0';
  }

  isActive(index: number) {
    return index === this.stepNo;
  }

  private setCurrentStepAndStepRapport() {
    this.steps.forEach((step) => (step.id === this.stepId ? (this.stepNo = this.steps.indexOf(step)) : null));
    this.totalSteps = this.steps.length;
    this.stepRapport = Math.round(((this.stepNo + 1) * 100) / this.totalSteps);
    this.setProgressbarColor();
  }

  private setProgressbarColor() {
    this.progressValue = Math.floor(100 / this.totalSteps) * (this.stepNo + 1) - 100;
    if (this.circularBar) {
      this.rd.setStyle(
        this.circularBar.nativeElement,
        'stroke-dashoffset',
        this.totalSteps === (this.stepNo + 1) ? 0 : ((100 - this.progressValue) / 100) * (Math.PI * (2 * this.radius)) - this.strokeDashOffset
      );
    }
  }
}
